import { Component, HostListener, inject, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Apollo } from "apollo-angular";
import {
  ArrowLeft01Icon,
  ArrowRight01Icon,
  Menu01Icon,
  Menu02Icon,
  Notification01Icon,
  PauseIcon,
  PlayIcon,
} from "@hugeicons/core-free-icons";

import { LandingSubscriptionComponent } from "./landing-subscription/landing-subscription.component";
import { SettingsService } from "../../services/settings.service";
import { environment } from "../../../environments/environment";
import { GET_ALL_ADVERTISMENT } from "../../store/entities/epaper-management/epaper.graphql";
import { READ_ATTACHMENT_BY_PATH } from "../../store/entities/shared/attachment.graphql";
import { NotificationService } from "../../services/notification.service";

@Component({
  selector: "app-main-landing-page",
  templateUrl: "./main-landing-page.component.html",
  styleUrls: ["./main-landing-page.component.scss"],
})
export class MainLandingPageComponent implements OnInit, OnDestroy {
  private readonly settings = inject(SettingsService);
  private notify = inject(NotificationService);

  adverts: any[] = [];
  loading = false;

  icons = {
    menu: Menu02Icon,
    bell: Notification01Icon,
    arrowLeft: ArrowLeft01Icon,
    arrowRight: ArrowRight01Icon,
    play: PlayIcon,
    pause: PauseIcon,
  };

  menus = [
    {
      title: "e-paper",
      link: "",
    },
    {
      title: "TSN",
      link: "",
    },
    {
      title: "Trending News",
      link: "",
    },
    {
      title: "Rate Card",
      link: "",
    },
    {
      title: "Mobile Apps",
      link: "",
    },
  ];

  slides: any[] = [];

  defaultSlides = [
    // {
    //   backgroundImage: "assets/images/paper1.jpg",
    //   title: "Tanzania's Most Trusted Source of News",
    //   subtitle:
    //     "With a rich legacy of credible reporting, Tanzania Standard Newspapers continues to deliver reliable stories, in-depth analysis, and nationwide coverage that keeps every citizen informed and empowered.",
    //   highlight: "Trusted",
    // },
    // {
    //   backgroundImage: "assets/images/paper2.jpg",
    //   title: "Breaking News That Matters",
    //   subtitle:
    //     "Get real-time updates from across Tanzania and the world. Our newsroom works around the clock to bring you accurate breaking stories, fast insights, and essential information as events unfold.",
    //   highlight: "Breaking",
    // },
    {
      backgroundImage: "assets/images/paper4.jpg",
      title: "Stories From Tanzania's Communities",
      subtitle:
        "Explore inspiring human-interest stories, local achievements, and voices from communities throughout the country. We highlight the people, culture, and everyday experiences that shape Tanzania.",
      highlight: "Community",
    },
    // {
    //   backgroundImage: "assets/images/paper5.jpg",
    //   title: "Insights Into National Affairs",
    //   subtitle:
    //     "Stay updated on Tanzania's political landscape, government initiatives, and national developments. Our comprehensive reporting provides clarity, context, and depth on the issues that influence the nation.",
    //   highlight: "National",
    // },
  ];

  images: string[] = [
    "assets/images/coursel1.jpeg",
    "assets/images/coursel2.jpeg",
    "assets/images/coursel3.jpeg",
    "assets/images/coursel4.svg",
  ];

  cards = [
    { title: "Fast Service", description: "We deliver quickly.", icon: "🚀" },
    { title: "Secure", description: "Your data is safe with us.", icon: "🔒" },
    { title: "Support", description: "24/7 customer support.", icon: "📞" },
  ];

  activeSection: string;
  pageYset: number;
  currentImageIndex: number = 0;
  currentSlideIndex: number = 0;
  autoPlayInterval: any;
  isPlaying: boolean = true;
  autoPlayDelay: number = 6000;
  animationState: string = "enter";
  progressWidth: string = "100%";

  currentPage: number = 0;
  pageSize: number = 5;

  faqs = [
    {
      question: "What is this system?",
      answer: "It is a Visitors and Attendance Tracking System.",
    },
    {
      question: "How do I register?",
      answer: "Click the register button on the landing page.",
    },
    {
      question: "Is there a mobile app?",
      answer: "Yes, you can use the mobile app with full features.",
    },
    {
      question: "Can I track attendance in real-time?",
      answer: "Yes, the system supports real-time attendance tracking.",
    },
    {
      question: "Who can use this system?",
      answer: "Institutes, organizations, and staff.",
    },
    {
      question: "Is there support?",
      answer: "Yes, contact our help desk via email or phone.",
    },
  ];

  constructor(private router: Router, private apollo: Apollo) {}

  ngOnInit() {
    this.slides = [...this.defaultSlides];
    this.fetchAdverts();
    this.startSlideshow();
  }

  // ✅ FIXED: Corrected to match GET_ALL_ADVERTISMENT query
 fetchAdverts() {
  this.loading = true;
  console.log('=== FETCHING ADVERTS ===');

  this.apollo.watchQuery({
    query: GET_ALL_ADVERTISMENT,
    variables: { 
      filtering: {
        pageNumber: 0,
      }
    },
    fetchPolicy: 'network-only'
  }).valueChanges.subscribe({
    next: (result: any) => {
      this.loading = false;
      
      console.log('=== FULL GRAPHQL RESPONSE ===');
      console.log('result.data:', result.data);

      // ✅ Get data from getAllAdvertsPageable
      const advertsData = result.data?.getAllAdvertsPageable?.data;
      
      if (!advertsData || !Array.isArray(advertsData) || advertsData.length === 0) {
        console.warn('⚠️ No adverts found in response');
        return;
      }

      console.log(`✅ Found ${advertsData.length} advert(s)`);
      
      // ✅ FIXED: Only filter by advertType, remove date filtering for now
      const inPageAdverts = advertsData.filter((advert: any) => {
        const isInPage = advert.advertType === 'IN_PAGE';
        console.log(`Advert "${advert.title}": type=${advert.advertType}, isInPage=${isInPage}`);
        return isInPage;
      });

      console.log(`✅ Found ${inPageAdverts.length} IN_PAGE advert(s)`);
      
      if (inPageAdverts.length === 0) {
        console.warn('⚠️ No IN_PAGE adverts found');
        return;
      }

      // Process adverts
      this.adverts = inPageAdverts;
      this.processAdverts();
    },
    error: (err) => {
      this.loading = false;
      console.error('❌ Error loading adverts:', err);
    }
  });
}

  // ✅ NEW: Process all adverts
  async processAdverts() {
    console.log('=== PROCESSING ADVERTS ===');
    const advertSlides: any[] = [];
    
    for (const advert of this.adverts) {
      console.log('Processing advert:', advert);
      console.log('Advert fields:', Object.keys(advert));

      // Get title and description
      const title = advert.title || advert.name || 'Featured Advertisement';
      const description = advert.description || advert.content || 'Check out our latest offers';
      
      // Get image path
      const imagePath = advert.imageUrl || 
                       advert.imagePath || 
                       advert.image || 
                       advert.url ||
                       advert.path;

      console.log('Title:', title);
      console.log('Description:', description);
      console.log('Image path:', imagePath);

      if (imagePath) {
        try {
          // Load the image
          const imageUrl = await this.loadAdvertImage(imagePath);
          
          if (imageUrl) {
            const titleWords = title.split(' ');
            const highlightWord = titleWords[Math.floor(titleWords.length / 2)] || titleWords[0] || '';

            const advertSlide = {
              backgroundImage: imageUrl,
              title: title,
              subtitle: description,
              highlight: highlightWord,
              isAdvert: true
            };

            advertSlides.push(advertSlide);
            console.log('✅ Added advert slide:', advertSlide.title);
          }
        } catch (error) {
          console.error('❌ Error loading advert image:', error);
        }
      } else {
        console.warn('⚠️ No image path found for advert');
      }
    }

    if (advertSlides.length > 0) {
      // Add advert slides at the beginning
      this.slides = [...advertSlides, ...this.defaultSlides];
      console.log(`✅ Updated slides with ${advertSlides.length} adverts`);
      console.log('Total slides:', this.slides.length);
    } else {
      console.warn('⚠️ No advert slides were created');
    }
  }

  // ✅ NEW: Load advert image as Promise
  loadAdvertImage(filePath: string): Promise<string | null> {
    console.log('Loading image for path:', filePath);

    return new Promise((resolve) => {
      // Check if it's a full URL
      if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
        console.log('Using full URL');
        resolve(filePath);
        return;
      }

      // Check if it's already base64
      if (filePath.startsWith('data:image')) {
        console.log('Using base64 data');
        resolve(filePath);
        return;
      }

      // Load as attachment
      this.apollo.query({
        query: READ_ATTACHMENT_BY_PATH,
        variables: { input: { filePath } },
        fetchPolicy: 'no-cache'
      }).subscribe({
        next: (res: any) => {
          const base64Data = res?.data?.getAttachment?.data?.filePath;
          
          if (base64Data) {
            const imageType = filePath.toLowerCase().endsWith('.png') ? 'png' : 'jpeg';
            const dataUrl = `data:image/${imageType};base64,${base64Data}`;
            console.log('✅ Image loaded via attachment');
            resolve(dataUrl);
          } else {
            console.warn('⚠️ No base64 data in response');
            resolve(null);
          }
        },
        error: (err) => {
          console.error('❌ Error loading attachment:', err);
          resolve(null);
        }
      });
    });
  }

  // Slideshow methods
  startSlideshow() {
    this.isPlaying = true;
    this.autoPlayInterval = setInterval(() => {
      this.nextSlide();
    }, this.autoPlayDelay);

    this.startProgressBar();
  }

  pauseSlideshow() {
    this.isPlaying = false;
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
    this.progressWidth = "0%";
  }

  playSlideshow() {
    if (!this.isPlaying) {
      this.startSlideshow();
    }
  }

  togglePlayPause() {
    if (this.isPlaying) {
      this.pauseSlideshow();
    } else {
      this.playSlideshow();
    }
  }

  nextSlide() {
    this.animationState = "exit";

    setTimeout(() => {
      this.currentSlideIndex =
        (this.currentSlideIndex + 1) % this.slides.length;
      this.animationState = "enter";
      this.startProgressBar();
    }, 1000);
  }

  prevSlide() {
    this.animationState = "exit";

    setTimeout(() => {
      this.currentSlideIndex =
        this.currentSlideIndex === 0
          ? this.slides.length - 1
          : this.currentSlideIndex - 1;
      this.animationState = "enter";
      this.startProgressBar();
    }, 600);
  }

  goToSlide(index: number) {
    if (index !== this.currentSlideIndex) {
      this.animationState = "exit";

      setTimeout(() => {
        this.currentSlideIndex = index;
        this.animationState = "enter";
        this.startProgressBar();
      }, 600);
    }
  }

  startProgressBar() {
    if (this.isPlaying) {
      this.progressWidth = "100%";
      setTimeout(() => {
        this.progressWidth = "0%";
      }, 50);
    }
  }

  startCarousel() {
    setInterval(() => {
      this.currentImageIndex =
        (this.currentImageIndex + 1) % this.images.length;
    }, 3000);
  }

  setImage(index: number) {
    this.currentImageIndex = index;
  }

  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    this.pageYset = window.pageYOffset;

    const sections = ["home", "features", "faq"];
    for (const sec of sections) {
      const el = document.getElementById(sec);
      if (el) {
        const rect = el.getBoundingClientRect();
        if (rect.top <= 60 && rect.bottom >= 60) {
          this.activeSection = sec;
        }
      }
    }
  }

  navigateToLogin(): void {
    this.router.navigate(["/login"]);
  }

  get filteredFaq() {
    const start = this.currentPage * this.pageSize;
    return this.faqs.slice(start, start + this.pageSize);
  }

  nextPage() {
    if ((this.currentPage + 1) * this.pageSize < this.faqs.length) {
      this.currentPage++;
    }
  }

  onViewRateCard(rateCard?: any) {
    this.settings.openDialogModal({
      component: LandingSubscriptionComponent,
      data: {
        rateCard,
      }
    });
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
    }
  }

  ngOnDestroy() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
    }
  }
}